<header
  class="flex items-center justify-between border-b border-black/10 px-4 py-3"
>
  <div class="flex items-center">
    <img [src]="logo()" alt="logo" class="h-8 object-contain" />
  </div>

  <div class="flex items-center gap-1">
    <div class="hidden sm:block">
      <bevvi-action-button
        label="New Chat"
        [icon]="icons.CHAT_CLIP"
        [appearance]="actionButtonAppearance.GHOST"
        [contentType]="actionButtonContent.ICON_TEXT"
        (buttonClick)="newChatClick.emit()"
      />
    </div>

    <div class="block sm:hidden">
      <bevvi-action-button
        [icon]="icons.CHAT_CLIP"
        [appearance]="actionButtonAppearance.GHOST"
        [contentType]="actionButtonContent.ICON"
        (buttonClick)="newChatClick.emit()"
      />
    </div>

    @if (showClose()) {
      <div class="block sm:hidden">
        <bevvi-action-button
          [icon]="icons.CROSS"
          [appearance]="actionButtonAppearance.GHOST"
          [contentType]="actionButtonContent.ICON"
          (buttonClick)="closeClick.emit()"
        />
      </div>
    }
  </div>
</header>
